import { Box, styled } from "@material-ui/core";
import { Title2 } from "components/design-system/atoms/Typography";
import Body from "components/design-system/atoms/Typography/Body";

const TurquoiseTitle2 = styled(Title2)(({ theme }) => ({
  color: theme.palette.turquoise.main,
  fontSize: 21,
  marginBottom: "10px",
}));

const BodyWithLineHeight = styled(Body)({
  lineHeight: "140%",
  fontSize: "16px",
  color: "secondary",
});

const BoldText = styled("span")({
  fontWeight: 600,
});

const DrawerWrapper = styled(Box)(({ theme }) => ({
  margin: "24px 8px 24px 8px",
  [theme.breakpoints.down("md")]: {
    margin: "16px 8px 16px 8px",
  },
}));

const BorderBottomBox = styled(Box)({
  borderBottom: "1px solid rgba(219, 223, 232, 0.6)",
});

export default function SecondHandDrawerContent() {
  return (
    <DrawerWrapper>
      <BorderBottomBox pb={5}>
        <Box>
          <BodyWithLineHeight>
            <TurquoiseTitle2>Reconditionné en France et Responsable</TurquoiseTitle2>
            <BoldText>
              Reconditionné dans nos ateliers en France, chaque appareil sauvé représente des centaines de kilos de
              déchets évités tout en valorisant l&apos;emploi local et l&apos;expertise française.
            </BoldText>
          </BodyWithLineHeight>
        </Box>
      </BorderBottomBox>
      <Box mt={5}>
        <TurquoiseTitle2> Sélection d&apos;experts</TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight>
            Nos réparateurs choisissent chaque appareil pour sa robustesse et sa réparabilité. Qui de mieux que ceux qui
            les connaissent sur le bout des doigts pour garantir leur potentiel?
            <Box>&nbsp;</Box>
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2>Révision minucieuse</TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight>
            Diagnostic complet selon 25 points de contrôle, remplacement des pièces défaillantes, tests et retests...
            Nos techniciens s&apos;assurent d&apos;un fonctionnement parfait avant validation.
            <Box>&nbsp;</Box>
          </BodyWithLineHeight>
        </Box>
      </Box>
      <Box mt={5}>
        <TurquoiseTitle2>Nettoyage impeccable</TurquoiseTitle2>
        <Box>
          <BodyWithLineHeight>
            Nettoyage approfondi de fond en comble pour que votre appareil retrouve tout son éclat. Il ne lui manque
            plus qu&apos;une séance photo pour rejoindre notre boutique !<Box>&nbsp;</Box>
          </BodyWithLineHeight>
        </Box>
      </Box>
    </DrawerWrapper>
  );
}
